<template>
  <div
    class="text-center"
    style="display: none"
  >
    <v-dialog
      v-model="dialog"
      width="500"
      attach=".map"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          <v-col
            class="pa-3 d-flex justify-space-between align-center"
            cols="12"
          >
            <span class="headline">{{ $i18n.t('dashboard.map.featureAttributes') }}</span>
            <span>
              <v-btn
                fab
                dark
                :title="$i18n.t('dashboard.map.deleteFeature')"
                small
                class="mr-1 btn--green"
                @click="deleteFeature"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-row v-if="fields.length === 0">
            <v-subheader style="height: auto; min-height: 48px;">
              <span>{{$i18n.t('dashboard.map.emptyFeatureAttributes')}}</span>
            </v-subheader>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-form>
                <template v-for="(field, idx) of fields">
                  <v-row
                    :key="idx"
                    class="pb-0"
                  >
                    <v-col>
                      <v-subheader style="height: auto; min-height: 48px;">
                        <span>{{field[$i18n.locale]}}</span>
                      </v-subheader>
                    </v-col>
                    <v-col cols="8">
                      <v-subheader style="height: auto; min-height: 48px;">
                        <span>{{selectedFeatureProperties[field.pl] || $i18n.t(`dashboard.table.empty`)}}</span>
                      </v-subheader>
                    </v-col>
                  </v-row>
                </template>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="primary"
            text
            @click="cancel"
          >{{ $i18n.t('dialog.confirmation.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    selectedFeatureProperties: {
      required: true,
      type: Object
    },
    fields: {
      required: true,
      type: Array
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    deleteFeature() {
      this.$emit('delete');
    }
  }
};
</script>
    
